<template>
    <div class="wrapper_group_dashboard">
        <div class="group_dashboard align-items-start justify-content-center">
            <div class="notification-card">
                <div class="notification-head mb-4 d-flex gap-3 flex-wrap flex-md-nowrap">
                    <div class="notification-icon d-flex justify-content-center align-items-center flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <g fill="none" fill-rule="evenodd">
                                <path
                                    d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                                <path fill="currentColor"
                                    d="M5 9a7 7 0 0 1 14 0v3.764l1.822 3.644A1.1 1.1 0 0 1 19.838 18h-3.964a4.002 4.002 0 0 1-7.748 0H4.162a1.1 1.1 0 0 1-.984-1.592L5 12.764zm5.268 9a2 2 0 0 0 3.464 0zM12 4a5 5 0 0 0-5 5v3.764a2 2 0 0 1-.211.894L5.619 16h12.763l-1.17-2.342a2 2 0 0 1-.212-.894V9a5 5 0 0 0-5-5" />
                            </g>
                        </svg>
                    </div>
                    <div class="notification-title">
                        <h1 class="mb-1">Email Notification</h1>
                        <p>
                            Manage which notifications you want to receive. Turn them on
                            or off anytime to stay updated without unnecessary alerts
                        </p>
                    </div>


                </div>
                <div class="notification_preference_wrapper">
                    <div class="select_category_wrapper">
                        <b-dropdown id="categoryDropdown" class="w-100" block :disabled="loadingCategories"
                            text="Select Category">
                            <template #button-content>
                                <div class="d-flex justify-content-between align-items-center w-100">
                                    <span v-if="selectedCategory">{{
                                        selectedCategory.name
                                        }}</span>
                                    <span v-else class="select-txt">Select Category</span>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24">
                                            <path fill="#464646" fill-rule="evenodd" d="m6 7l6 6l6-6l2 2l-8 8l-8-8z" />
                                        </svg>
                                    </div>
                                </div>
                            </template>

                            <div class="option-wrapper">
                                <b-dropdown-item v-for="category in categories" :key="category.id"
                                    @click="selectCategory(category)">
                                    {{ category.name }}
                                </b-dropdown-item>
                            </div>
                        </b-dropdown>
                    </div>

                    <div v-if="selectedCategory" class="selected_category_list mt-3">
                        <div
                            class="selected_title_wrapper d-flex justify-content-between gap-3 align-items-center mb-4">
                            <h6 class="title-wrapper mb-0">
                                {{ selectedCategory.name }}
                            </h6>
                            <div class="toggle-switch-wrapper ms-1">
                                <label class="switch">
                                    <input type="checkbox" v-model="selectedCategory.enabled"
                                        @change="updateCategoryStatus" :disabled="updatingCategoryStatus" />
                                    <div class="sliders round"></div>
                                </label>
                            </div>
                        </div>
                        <div v-if="loadingSubCategories" class="text-center">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span class="ml-2">Loading subcategories...</span>
                        </div>
                        <ul class="listwrapper d-flex flex-column gap-4 mb-0" v-else-if="selectedCategory">
                            <li class="list_items d-flex " v-for="subCategory in subCategories" :key="subCategory.id">
                                <div class="toggle-switch-wrapper switch-box ms-1">
                                    <label class="switch" :for="'subcat-' + subCategory.id">
                                        <input type="checkbox" :id="'subcat-' + subCategory.id"
                                            :checked="subCategory.enabled"
                                            @change="updateSubCategoryStatus(subCategory)"
                                            :disabled="updatingSubCategoryStatus" />
                                        <div class="sliders round"></div>
                                    </label>
                                </div>
                                <div>
                                 <h3 class="h6 mb-1">{{ subCategory.name }}</h3>
                                <p class="text-muted mb-0 f-14">
                                    {{ subCategory.label || 'No description available' }}
                                </p>
                                </div>
                             
                            </li>
                        </ul>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    name: "Setting",
    data() {
        return {
            categories: [],
            subCategories: [],
            selectedCategoryId: '',
            selectedCategory: null,
            loadingSubCategories: false,
            loadingCategories: false,
            updatingCategoryStatus: false,
            updatingSubCategoryStatus: false,
            unsubscribedCategories: [],
            unsubscribedSubCategories: []
        };
    },
    computed: {
        userEmail() {
            return this.$store.getters.groupEmail || '';
        }
    },
    async mounted() {
        await this.fetchCategories();
        await this.fetchUnsubscribedCategories();
        this.updateCategoryStates();

    },
    methods: {
            selectCategory(category) {
      this.selectedCategoryId = category.id;
      this.selectedCategory = category;
      this.onCategoryChange();
    },
        async fetchCategories() {
            this.loadingCategories = true;
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_URL}message-center/categories`);
                if (response.data && response.data.data && response.data.data.data) {
                    this.categories = response.data.data.data.map(category => ({
                        ...category,
                        enabled: true
                    }));
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
                this.$notify("Failed to load categories", "error");
            } finally {
                this.loadingCategories = false;
            }
        },

        async fetchUnsubscribedCategories() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_URL}message-center/fetch-unsubscribed-users`, {
                    params: {
                        per_page: 100,
                        page: 1,
                        email: this.userEmail,
                        category_name: '',
                        reason: ''
                    }
                });

                if (response.data && response.data.data && response.data.data.data && response.data.data.data.data) {
                    const userUnsubscribedRecords = response.data.data.data.data.filter(item => {
                        return item.user_lists && item.user_lists.email === this.userEmail;
                    });
                    this.unsubscribedCategories = userUnsubscribedRecords
                        .filter(item => item.status === 0 || item.reason === 'manually unsubscribed')
                        .map(item => parseInt(item.categories_id));

                    // Extract unsubscribed subcategories from all records
                    this.unsubscribedSubCategories = userUnsubscribedRecords
                        .filter(item => item.sub_categories_id && item.sub_categories_id.length > 0)
                        .flatMap(item => item.sub_categories_id.map(id => parseInt(id)));
                } else {
                    this.unsubscribedCategories = [];
                    this.unsubscribedSubCategories = [];
                }
            } catch (error) {
                console.error('Error fetching unsubscribed categories:', error);
                this.unsubscribedCategories = [];
                this.unsubscribedSubCategories = [];
            }
        },

        updateCategoryStates() {
            this.categories = this.categories.map(category => ({
                ...category,
                enabled: !this.unsubscribedCategories.includes(category.id)
            }));
        },

        async fetchSubCategories(categoryId) {
            this.loadingSubCategories = true;
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_URL}message-center/categories/${categoryId}/email-configurations`);
                if (response.data && response.data.data && response.data.data.data) {
                    this.subCategories = response.data.data.data.map(subCategory => ({
                        ...subCategory,
                        enabled: !this.unsubscribedSubCategories.includes(subCategory.id)
                    }));
                    this.updateMainCategoryToggle();
                }
            } catch (error) {
                console.error('Error fetching sub-categories:', error);
                this.$notify("Failed to load sub-categories", "error");
                this.subCategories = [];
            } finally {
                this.loadingSubCategories = false;
            }
        },
        updateMainCategoryToggle() {
            if (this.selectedCategory && this.subCategories.length > 0) {
                // Main category should be ON if at least one subcategory is ON
                const hasEnabledSubCategory = this.subCategories.some(sub => sub.enabled);
                this.selectedCategory.enabled = hasEnabledSubCategory;

                // Update the category in the main categories array
                const categoryIndex = this.categories.findIndex(cat => cat.id === this.selectedCategory.id);
                if (categoryIndex !== -1) {
                    this.categories[categoryIndex].enabled = hasEnabledSubCategory;
                }
            }
        },

        async onCategoryChange() {
            if (this.selectedCategoryId) {
                this.selectedCategory = this.categories.find(cat => cat.id == this.selectedCategoryId);
                await this.fetchSubCategories(this.selectedCategoryId);
            } else {
                this.selectedCategory = null;
                this.subCategories = [];
            }
        },

        async updateCategoryStatus() {
            if (!this.selectedCategory || !this.userEmail) {
                this.$notify("Missing required information", "error");
                return;
            }

            this.updatingCategoryStatus = true;

            try {
                if (this.selectedCategory.enabled) {
                    await this.subscribeToCategoryNotifications();
                    this.unsubscribedCategories = this.unsubscribedCategories.filter(id => id !== this.selectedCategory.id);
                    const currentSubCategoryIds = this.subCategories.map(sub => sub.id);
                    this.unsubscribedSubCategories = this.unsubscribedSubCategories.filter(id =>
                        !currentSubCategoryIds.includes(id)
                    );

                    // Enable all subcategories
                    this.subCategories = this.subCategories.map(subCategory => ({
                        ...subCategory,
                        enabled: true
                    }));
                } else {
                    if (!this.unsubscribedCategories.includes(this.selectedCategory.id)) {
                        this.unsubscribedCategories.push(this.selectedCategory.id);
                    }
                    this.subCategories.forEach(subCategory => {
                        if (!this.unsubscribedSubCategories.includes(subCategory.id)) {
                            this.unsubscribedSubCategories.push(subCategory.id);
                        }
                    });
                    this.subCategories = this.subCategories.map(subCategory => ({
                        ...subCategory,
                        enabled: false
                    }));
                    await this.unsubscribeFromCategoryNotifications(...this.subCategories.map(sub => sub.id));
                }

                const categoryIndex = this.categories.findIndex(cat => cat.id === this.selectedCategory.id);
                if (categoryIndex !== -1) {
                    this.categories[categoryIndex].enabled = this.selectedCategory.enabled;
                }

                this.$notify(
                    `Successfully ${this.selectedCategory.enabled ? 'enabled' : 'disabled'} notifications for ${this.selectedCategory.name}`,
                    "success"
                );
            } catch (error) {
                this.$notify("Failed to update category status", "error");
                this.selectedCategory.enabled = !this.selectedCategory.enabled;
            } finally {
                this.updatingCategoryStatus = false;
            }
        },

        async updateSubCategoryStatus(subCategory) {
            if (!this.selectedCategory || !this.userEmail) {
                this.$notify("Missing required information", "error");
                return;
            }

            this.updatingSubCategoryStatus = true;

            console.log(subCategory)
            console.log(subCategory.enabled)

            const subCategoryName = subCategory.name || subCategory.title || subCategory.label || `Subcategory (ID: ${subCategory.id})`;

            subCategory.enabled = !subCategory.enabled;
            try {
                if (subCategory.enabled || subCategory.enabled === true) {
                    await this.subscribeToSubCategoryNotifications(subCategory);
                    this.unsubscribedSubCategories = this.unsubscribedSubCategories.filter(id => id !== subCategory.id);

                    if (!this.selectedCategory.enabled) {
                        this.selectedCategory.enabled = true;
                        const categoryIndex = this.categories.findIndex(cat => cat.id === this.selectedCategory.id);
                        if (categoryIndex !== -1) {
                            this.categories[categoryIndex].enabled = true;
                        }
                        this.unsubscribedCategories = this.unsubscribedCategories.filter(id => id !== this.selectedCategory.id);
                    }

                    this.$notify(
                        `Successfully enabled notifications for ${subCategoryName}`,
                        "success"
                    );
                } else {
                    console.log("disable")
                    await this.unsubscribeFromSubCategoryNotifications(subCategory);
                    if (!this.unsubscribedSubCategories.includes(subCategory.id)) {
                        this.unsubscribedSubCategories.push(subCategory.id);
                    }

                    this.updateMainCategoryToggle();

                    this.$notify(
                        `Successfully disabled notifications for ${subCategoryName}`,
                        "success"
                    );
                }
            } catch (error) {
                this.$notify(`Failed to update notifications for "${subCategoryName}"`, "error");
                subCategory.enabled = !subCategory.enabled;
            } finally {
                this.updatingSubCategoryStatus = false;
            }
        },

        async subscribeToCategoryNotifications() {
            const payload = {
                status: 0,
                email: this.userEmail,
                categories_id: this.selectedCategory.id.toString(),
                sub_categories_id: []
            };

            const response = await axios.post(`${process.env.VUE_APP_API_URL}message-center/update-subscription`, payload);

            if (!response.data || response.data.status !== 'success') {
                throw new Error('Failed to subscribe to notifications');
            }
        },

        async unsubscribeFromCategoryNotifications(...subCategoriesIds) {

            const payload = {
                email: this.userEmail,
                categories_id: this.selectedCategory.id.toString(),
                reason: "manually unsubscribed",
                description: "",
                sub_categories_id: subCategoriesIds
            };

            const response = await axios.post(`${process.env.VUE_APP_API_URL}message-center/unsubscribe-user`, payload);

            if (!response.data || response.data.status !== 'success') {
                throw new Error('Failed to unsubscribe from notifications');
            }
        },

        async subscribeToSubCategoryNotifications(subCategory) {
            const currentUnsubscribedSubCategoryIds = this.subCategories
                .filter(sub => !sub.enabled)
                .map(sub => sub.id.toString());

            const payload = {
                status: 0,
                email: this.userEmail,
                categories_id: this.selectedCategory.id.toString(),
                sub_categories_id: currentUnsubscribedSubCategoryIds
            };

            const response = await axios.post(`${process.env.VUE_APP_API_URL}message-center/update-subscription`, payload);

            if (!response.data || response.data.status !== 'success') {
                throw new Error('Failed to subscribe to subcategory notifications');
            }
        },

        async unsubscribeFromSubCategoryNotifications(subCategory) {
            const currentUnsubscribedSubCategoryIds = this.subCategories
                .filter(sub => !sub.enabled || sub.id === subCategory.id)
                .map(sub => sub.id.toString());

            const payload = {
                email: this.userEmail,
                categories_id: this.selectedCategory.id.toString(),
                reason: "manually unsubscribed",
                description: "",
                sub_categories_id: currentUnsubscribedSubCategoryIds
            };

            const response = await axios.post(`${process.env.VUE_APP_API_URL}message-center/unsubscribe-user`, payload);

            if (!response.data || response.data.status !== 'success') {
                throw new Error('Failed to unsubscribe from subcategory notifications');
            }
        }
    }
};
</script>

<style scoped>
.input-required {
    color: red;
}

.toggle-eye-icon {
    cursor: pointer;
}

.group_dashboard {
    margin-bottom: 5em;
}
</style>

<style src="@/assets/css/group_dashboard/notification.css"></style>
